<h2 mat-dialog-title class="flex flex-row justify-center">{{ data.title }}</h2>
<mat-dialog-content
  class="flex flex-row justify-center text-center"
  style="min-height: 80px; overflow-y: auto"
>
  <p>{{ data.message }}</p>
</mat-dialog-content>
<mat-dialog-actions align="end" class="flex flex-row justify-center">
  <button mat-button [mat-dialog-close]="true" id="close">
    {{ 'Close' | transloco }}
  </button>
</mat-dialog-actions>
